
window.HSSearchFields = (function () {
  'use strict';

  var FIELDS = 'title';
  var PREFIX = 'none';
  var STORAGE_KEY = 'hs_search_phrase';

  function phrase(raw) {
    var original = String(raw || '').trim();
    if (!original || /^".*"$/.test(original)) return null;
    var words = original.replace(/"/g, ' ').replace(/\s+/g, ' ').trim();
    if (words.indexOf(' ') === -1) return null;
    return { query: '"' + words + '"', original: original };
  }

  function readMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function remember(p) {
    try {
      var m = readMap();
      var keys = Object.keys(m);
      if (keys.length > 30) delete m[keys[0]];
      m[p.query] = p.original;
      if (p.filters && p.filters.length) m[p.query + '#f'] = p.filters.map(function (f) { return f.name; }).join(',');
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  function originalFor(q) { return readMap()[q] || null; }

  function escHtml(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function unrewrite(text, p) {
    var back = escHtml(p.original);
    return text.split(p.query).join(back).split(escHtml(p.query)).join(back);
  }


  function andQuery(raw) {
    var words = String(raw || '').toLowerCase().split(/\s+/)
      .map(function (w) { return w.replace(/[^a-z0-9.\-]/g, ''); })
      .filter(Boolean);
    return words.map(function (w) {
      var forms = [w];
      if (!/\d/.test(w)) {
        if (w.length > 3 && w.charAt(w.length - 1) === 's') forms.push(w.slice(0, -1));
        else forms.push(w + 's');
      }
      var terms = forms.map(function (f) { return 'title:' + f; });
      return terms.length > 1 ? '(' + terms.join(' OR ') + ')' : terms[0];
    }).join(' ');
  }

  function relaxIfEmpty(text, p, buildUrl, signal) {
    if (text.indexOf('/products/') !== -1) return text;         
    var rq = andQuery(p.original);
    return fetch(buildUrl(rq), { signal: signal })
      .then(function (r) { return r.ok ? r.text() : text; })
      .then(function (t) { return unrewrite(t, { query: rq, original: p.original }); })
      .catch(function (e) { if (e && e.name === 'AbortError') throw e; return text; });
  }

  var INDEX_KEY = 'hs_filter_index';

  function norm(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function singular(k) { return (k.length > 3 && k.charAt(k.length - 1) === 's') ? k.slice(0, -1) : k; }

  function getIndex() {
    try { return JSON.parse(sessionStorage.getItem(INDEX_KEY) || '{}'); } catch (e) { return {}; }
  }
  function mergeIndex(add) {
    var idx = getIndex();
    Object.keys(add).forEach(function (key) {
      idx[key] = idx[key] || [];
      add[key].forEach(function (h) {
        if (!idx[key].some(function (x) { return x.name === h.name && x.value === h.value; })) idx[key].push(h);
      });
    });
    try { sessionStorage.setItem(INDEX_KEY, JSON.stringify(idx)); } catch (e) { /* ignore */ }
    return idx;
  }
  function learnFrom(doc) {
    var found = {};
    var els = doc.querySelectorAll('input[type="checkbox"][name^="filter."]');
    Array.prototype.forEach.call(els, function (el) {
      var name = el.getAttribute('name');
      var value = el.getAttribute('value');
      var key = norm(value);
      if (!name || !value || !key || name === 'filter.v.availability') return;
      found[key] = found[key] || [];
      if (!found[key].some(function (x) { return x.name === name && x.value === value; })) found[key].push({ name: name, value: value });
    });
    return found;
  }
  function learnRemote() {
    fetch('/search?q=ring&options%5Bfields%5D=title&options%5Bprefix%5D=none')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        mergeIndex(learnFrom(new DOMParser().parseFromString(html, 'text/html')));
      })
      .catch(function () { /* search keeps working without the filter index */ });
  }

  function splitFilters(raw, idx) {
    var words = String(raw || '').trim().split(/\s+/).filter(Boolean);
    if (words.length < 2) return null;
    var used = words.map(function () { return false; });
    var filters = [];
    for (var len = Math.min(3, words.length); len >= 1; len--) {
      for (var i = 0; i + len <= words.length; i++) {
        var clash = false;
        for (var j = i; j < i + len; j++) if (used[j]) clash = true;
        if (clash) continue;
        var key = norm(words.slice(i, i + len).join(' '));
        var hit = key && (idx[key] || idx[singular(key)] || idx[key + 's']);
        if (hit) {
          filters.push(hit[0]);
          for (var k = i; k < i + len; k++) used[k] = true;
        }
      }
    }
    var rest = words.filter(function (w, n) { return !used[n]; });
    if (!filters.length || !rest.length) return null;
    return { filters: filters, rest: rest.join(' ') };
  }

  function planFull(raw) {
    var original = String(raw || '').trim();
    var sp = splitFilters(original, getIndex());
    if (sp) return { query: andQuery(sp.rest), original: original, filters: sp.filters };
    return phrase(original);
  }

  function hasResults() {
    return !!document.querySelector('#product-grid .grid__item, #ProductGridContainer .grid__item, .template-search__results .grid__item');
  }

  function setHidden(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }
  function applyToForm(form) {
    if (!form || !form.querySelector || !form.querySelector('input[name="q"]')) return;
    setHidden(form, 'options[fields]', FIELDS);
    setHidden(form, 'options[prefix]', PREFIX);
  }

  function install() {
    if (window.__hsSearchFieldsInstalled) return;
    window.__hsSearchFieldsInstalled = true;

    var isSearchPage = /\/search\/?$/.test(window.location.pathname);
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    if (isSearchPage) mergeIndex(learnFrom(document));
    if (!Object.keys(getIndex()).length && !isSearchPage) learnRemote();

    if (isSearchPage && !inEditor) {
      var u = new URL(window.location.href);
      var q0 = u.searchParams.get('q');
      if (q0 && !u.searchParams.has('options[fields]')) {
        var p0 = planFull(q0);
        if (p0) {
          remember(p0);
          u.searchParams.set('q', p0.query);
          (p0.filters || []).forEach(function (f) { u.searchParams.append(f.name, f.value); });
        }
        u.searchParams.set('options[fields]', FIELDS);
        u.searchParams.set('options[prefix]', PREFIX);
        window.location.replace(u.toString());
        return;
      }
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/search"]')) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      applyToForm(form);

      var p = planFull(input.value);
      if (!p) return;
      remember(p);

      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'q';
      hidden.value = p.query;
      input.removeAttribute('name');
      form.appendChild(hidden);
      var extra = (p.filters || []).map(function (f) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = f.name;
        h.value = f.value;
        form.appendChild(h);
        return h;
      });
      setTimeout(function () {        
        input.setAttribute('name', 'q');
        if (hidden.parentNode) hidden.parentNode.removeChild(hidden);
        extra.forEach(function (h) { if (h.parentNode) h.parentNode.removeChild(h); });
      }, 0);
    }, true);

    document.addEventListener('change', function (e) {
      if (isSearchPage && e.target && e.target.form) applyToForm(e.target.form);
    }, true);

    function restoreDisplay() {
      var q = new URL(window.location.href).searchParams.get('q');
      var orig = q && originalFor(q);
      if (!orig) return;
      document.querySelectorAll('input[name="q"]').forEach(function (el) {
        if (el.type !== 'hidden' && el.value === q) el.value = orig;
      });
      var scope = document.querySelector('main') || document.body;
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf(q) !== -1) node.nodeValue = node.nodeValue.split(q).join(orig);
      }
    }
    function applyToPageForms() {
      document.querySelectorAll('form').forEach(applyToForm);
      mergeIndex(learnFrom(document));
    }
    function relaxedNotice(words, kind) {
      if (!hasResults() || document.getElementById('hs-search-relaxed')) return;
      var box = document.createElement('p');
      box.id = 'hs-search-relaxed';
      box.setAttribute('role', 'status');
      box.style.cssText = 'text-align:center;padding:1rem 1.5rem;margin:0;';
      box.textContent = kind === '2'
        ? 'No product matched the filter for \u201C' + words + '\u201D. Showing products whose title contains every one of these words.'
        : 'No product title contains the exact phrase \u201C' + words + '\u201D. Showing products whose title contains every one of these words.';
      var main = document.querySelector('main');
      if (main) main.insertBefore(box, main.firstChild);
    }

    function onReady() {
      if (!isSearchPage) return;

      var cur = new URL(window.location.href);
      var q = cur.searchParams.get('q');
      var filterKeys = Array.from(cur.searchParams.keys()).filter(function (k) { return k.indexOf('filter.') === 0; });
      var planNames = ((q && originalFor(q + '#f')) || '').split(',').filter(Boolean);
      var ownFilters = planNames.length > 0 && filterKeys.every(function (k) { return planNames.indexOf(k) !== -1; });
      var noFilters = filterKeys.length === 0;
      if (q && originalFor(q) && !cur.searchParams.has('relaxed') && (noFilters || ownFilters) && !hasResults()) {
        var typed = originalFor(q);
        var rq = andQuery(typed);
        remember({ query: rq, original: typed });
        cur.searchParams.set('q', rq);
        cur.searchParams.set('relaxed', noFilters ? '1' : '2');
        filterKeys.forEach(function (k) { cur.searchParams.delete(k); });
        window.location.replace(cur.toString());
        return;
      }
      if (cur.searchParams.has('relaxed')) relaxedNotice(originalFor(q) || q, cur.searchParams.get('relaxed'));

      applyToPageForms();
      restoreDisplay();
      var main = document.querySelector('main');
      if (main && 'MutationObserver' in window) {
        var t;
        new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(function () { applyToPageForms(); restoreDisplay(); }, 50);   // filters re-render via AJAX
        }).observe(main, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
    else onReady();
  }

  return { FIELDS: FIELDS, PREFIX: PREFIX, phrase: phrase, remember: remember, unrewrite: unrewrite, andQuery: andQuery, relaxIfEmpty: relaxIfEmpty, getIndex: getIndex, splitFilters: splitFilters, planFull: planFull, install: install };
})();

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');


    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);
      searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      return;
    }

    const searchDeferred = this.dispatchSearchUpdateEvent(searchTerm);

    const searchFields = window.HSSearchFields
      ? `&resources%5Boptions%5D%5Bfields%5D=${encodeURIComponent(window.HSSearchFields.FIELDS)}`
      : '';
    const phrase = window.HSSearchFields ? window.HSSearchFields.phrase(searchTerm) : null;
    if (phrase) window.HSSearchFields.remember(phrase);
    const sentTerm = phrase ? phrase.query : searchTerm;

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(sentTerm)}&section_id=predictive-search${searchFields}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) =>
        phrase
          ? window.HSSearchFields.relaxIfEmpty(
              text,
              phrase,
              (q) => `${routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search${searchFields}`,
              this.abortController.signal
            )
          : text
      )
      .then((text) => {
        if (phrase) text = window.HSSearchFields.unrewrite(text, phrase);
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);

        searchDeferred?.resolve({ totalCount: this.getTotalResultCount() });
      })
      .catch((error) => {
        if (error?.code === 20) {
          searchDeferred?.reject(error);
          return;
        }
        searchDeferred?.reject(error);
        this.close();
        throw error;
      });
  }

  getTotalResultCount() {
    return parseInt(this.predictiveSearchResults.querySelector('[data-total-results]')?.dataset.totalResults) || 0;
  }

  dispatchSearchUpdateEvent(query) {
    const { SearchUpdateEvent } = window.StandardEvents || {};
    if (!SearchUpdateEvent) return null;

    const deferred = SearchUpdateEvent.createPromise();
    this.dispatchEvent(
      new SearchUpdateEvent({
        search: { query },
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

window.HSSearchFields.install();